import React from "react";
import Chart from "react-apexcharts";
import { useTheme } from "@mui/material/styles";

export default function ApexInventoryChart({ data }) {
    const theme = useTheme();

    // data format: [{ name: "In Stock", value: 100 }, ...]
    const series = React.useMemo(() => (Array.isArray(data) && data.length > 0
        ? data.map(item => item.value)
        : [65, 20, 15]), [data]);

    const labels = React.useMemo(() => (Array.isArray(data) && data.length > 0
        ? data.map(item => item.name)
        : ["In Stock", "Low Stock", "Expiring"]), [data]);

    const options = React.useMemo(() => ({
        chart: {
            id: "dashboard-inventory-donut",
            type: "donut",
            fontFamily: "inherit"
        },
        labels: labels,
        colors: [
            theme.palette.success.main,
            theme.palette.warning.main,
            theme.palette.error.main
        ],
        plotOptions: {
            pie: {
                donut: {
                    size: "75%",
                    labels: {
                        show: true,
                        total: {
                            show: true,
                            label: "Status",
                            fontSize: "14px",
                            fontWeight: 600,
                            color: theme.palette.text.secondary,
                            formatter: () => "Inventory"
                        },
                        value: {
                            show: true,
                            fontSize: "24px",
                            fontWeight: 800,
                            color: theme.palette.text.primary,
                            offsetY: 2,
                            formatter: (val) => val
                        }
                    }
                }
            }
        },
        dataLabels: { enabled: false },
        legend: {
            position: "bottom",
            fontSize: "13px",
            fontWeight: 500,
            labels: { colors: theme.palette.text.primary },
            markers: { radius: 12 },
            onItemClick: { toggleDataSeries: false }
        },
        stroke: { width: 0 },
        tooltip: {
            theme: theme.palette.mode,
            fillSeriesColor: false
        }
    }), [theme.palette.success.main, theme.palette.warning.main, theme.palette.error.main, theme.palette.text.secondary, theme.palette.text.primary, theme.palette.mode, labels]);

    return (
        <div className="apex-chart-wrapper" style={{ width: '100%', height: '100%' }}>
            <Chart options={options} series={series} type="donut" height="100%" />
        </div>
    );
}
